// eslint-disable-next-line
import { sendEvent } from "@JohnLewisPartnership/experiments-utils";
import { clientLogger } from "@/utils/clientLogger";

export function sendMonetateEvent(eventName: string) {
  clientLogger.log("Sending Monetate event:", eventName);
  sendEvent(eventName);
}
